import BookingType from '../models/BookingType'
import Booking from "../models/Booking";

export default class GoogleTagManagerService {
  appName: string = 'Access Collins'

  trackViewBookingTypes (types: BookingType[], venueName: string) {
    if (window.dataLayer) {
      window.dataLayer.push(
        {
          ecommerce: null
        }
      )

      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_id: 'bookingTypes',
          item_list_name: 'Booking Types',
          items: types.map((type: BookingType) => {
            return {
              item_id: type.id,
              item_name: type.name,
              item_category: this.appName,
              item_brand: venueName
            }
          })
        }
      })
    }
  }

  trackViewBookingType (type: BookingType, booking:Booking) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          value: 0,
          items: [
            {
              item_id: type.id,
              item_name: type.name,
              item_category: this.appName,
              item_brand: booking.venue ? booking.venue.name : '',
              item_list_id: 'bookingTypes',
              item_list_name: 'Booking Types',
              price: 0,
              quantity: booking.pax
            }
          ]
        }
      })
    }
  }

  trackSelectBookingType (type: BookingType, booking: Booking) {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          value: 0,
          items: [
            {
              item_id: type.id,
              item_name: type.name,
              item_category: this.appName,
              item_brand: booking.venue ? booking.venue.name : '',
              item_list_id: 'bookingTypes',
              item_list_name: 'Booking Types',
              price: 0,
              quantity: booking.pax
            }
          ]
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/GoogleTagManagerService.ts